const gameIdsParamKey = 'gameIds'

/**
 * Reads gameIds from search params, supporting both repeated params and a comma-joined single param.
 */
export const parseGameIdsParam = (params: URLSearchParams): string[] => {
  const gameIds = params
    .getAll(gameIdsParamKey)
    .flatMap((value) => value.split(','))
    .map((gameId) => gameId.trim())
    .filter(Boolean)

  return Array.from(new Set(gameIds))
}

/**
 * Serializes search params with the given game merged into gameIds (deduped). gameIds is written as a single
 * comma-joined param with raw commas, matching the Live Events Tracker's query-string `arrayFormat: 'comma'` format.
 * Other params keep their order and values.
 */
export const mergeGameIdIntoSearchParams = (params: URLSearchParams, gameId?: string): string => {
  const existingGameIds = parseGameIdsParam(params)
  const gameIds = gameId && !existingGameIds.includes(gameId) ? [...existingGameIds, gameId] : existingGameIds
  const gameIdsPart = gameIds.length > 0 ? `${gameIdsParamKey}=${gameIds.map(encodeURIComponent).join(',')}` : undefined

  const parts: string[] = []
  let gameIdsWritten = false
  params.forEach((value, key) => {
    if (key === gameIdsParamKey) {
      if (!gameIdsWritten && gameIdsPart) parts.push(gameIdsPart)
      gameIdsWritten = true
      return
    }
    parts.push(new URLSearchParams([[key, value]]).toString())
  })

  if (!gameIdsWritten && gameIdsPart) parts.push(gameIdsPart)

  return parts.join('&')
}
